<template>
  <div 
    @click="$emit('click')"
    class="flex-1 px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors border-r border-gray-200"
    :class="inputClasses"
  >
    <div class="flex items-center justify-between">
      <div class="flex-1">
        <div class="text-xs font-medium text-gray-600 mb-1">{{ label }}</div>
        <div class="text-sm font-medium text-gray-900">
          {{ displayValue }}
        </div>
      </div>
      <component :is="iconComponent" class="w-4 h-4 text-gray-400 ml-2" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CalendarToday from 'vue-material-design-icons/CalendarToday.vue'
import ArrowDown from 'vue-material-design-icons/ArrowDown.vue'

interface Props {
  label: string
  date: Date | null
  placeholder: string
  isActive: boolean
  icon?: 'CalendarToday' | 'ArrowDown'
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  icon: 'CalendarToday',
  disabled: false
})

const displayValue = computed(() => {
  if (!props.date) return props.placeholder
  return props.date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  })
})

const inputClasses = computed(() => ({
  'bg-blue-50 border-blue-300': props.isActive,
  'opacity-50 cursor-not-allowed': props.disabled
}))

const iconComponent = computed(() => {
  return props.icon === 'ArrowDown' ? ArrowDown : CalendarToday
})
</script> 